import {CustomInvoicesHistoryActions, LOAD_INVOICES_FAIL, LOAD_INVOICES_SUCCESS} from '../actions/custom-invoices-history.actions';
import {InvoiceHistoryList} from '../../../invoices.model';

export const initialState: InvoiceHistoryList = {
  invoices: [],
  pagination: {},
  sorts: [],
};

export function reducerInvoiceHistoryList(
  state = initialState,
  action: CustomInvoicesHistoryActions
): InvoiceHistoryList {
  switch (action.type) {
    case LOAD_INVOICES_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }

    case LOAD_INVOICES_FAIL: {
      return initialState;
    }
  }

  return state;
}


